export enum PageRoutes {
	// Passengers / Business / Careers
	Home = '/',
	Blogs = '/blogs',
	ParkingAvailability = '/parking-availability',
	Flights = '/flights',
	FlightDetail = '/flight',
	ShopDineRelax = '/shop-dine-relax',
	Security = '/security',
	DirectionsTraffic = '/directions-and-traffic',
	NonStopDestinations = '/nonstop-destinations',
	Map = '/map',
	Search = '/search',
	GroundTransportation = '/terminal-information/ground-transportation',
	Privacy = '/privacy-policy',
	WhereWeFly = '/voyager',

	// Business
	BusinessHome = '/business',
	News = '/business/newsroom/news',
	Newsroom = '/business/newsroom',
	PressReleases = '/business/newsroom/press-releases',
	MediaResources = '/business/newsroom/media-resources',
	MediaLibrary = '/business/newsroom/media-library',
	MediaContacts = '/business/newsroom/media-contacts',

	// Careers
	CareersHome = '/careers',
	Jobs = '/careers/jobs',

	// OXD
	OxdAirportHome = '/oxd-airport',
	OxdAbout = '/oxd-airport/about',
	OxdAirportServices = '/oxd-airport/airport-services',
	OxdFees = '/oxd-airport/oxd-airport-fees',
	OxdHangarOfficeLeasing = '/oxd-airport/hangar-office-leasing',
	PilotInfo = '/oxd-airport/pilot-info',
}
